// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.whats-new {
  background: var(--bg-light);
}

.whats-new__head {
  margin-bottom: 44px;
}

.whats-new__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
}

.whats-new__card {
  display: flex;
  gap: 16px;
  background: #fff;
  border-radius: var(--radius-md);
  padding: 26px;
  border: 1px solid var(--border-soft);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.whats-new__card:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-sm);
}

.whats-new__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 14px;
  color: var(--teal-dark);
  background: linear-gradient(135deg, var(--teal-tint), var(--amber-tint));
}

.whats-new__card h3 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 6px;
}

.whats-new__card p {
  font-size: 13.5px;
}

@media (max-width: 980px) {
  .whats-new__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 620px) {
  .whats-new__grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WhatsNew.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,wEAAwE;AAC1E;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".whats-new {\n  background: var(--bg-light);\n}\n\n.whats-new__head {\n  margin-bottom: 44px;\n}\n\n.whats-new__grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 22px;\n}\n\n.whats-new__card {\n  display: flex;\n  gap: 16px;\n  background: #fff;\n  border-radius: var(--radius-md);\n  padding: 26px;\n  border: 1px solid var(--border-soft);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.whats-new__card:hover {\n  transform: translateY(-6px);\n  box-shadow: var(--shadow-sm);\n}\n\n.whats-new__icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  border-radius: 14px;\n  color: var(--teal-dark);\n  background: linear-gradient(135deg, var(--teal-tint), var(--amber-tint));\n}\n\n.whats-new__card h3 {\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n\n.whats-new__card p {\n  font-size: 13.5px;\n}\n\n@media (max-width: 980px) {\n  .whats-new__grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 620px) {\n  .whats-new__grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
